import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import cx from 'classnames';

import useStyles from './styles';

interface CardSectionProps {
  classes?: {
    wrapper?: string;
    title?: string;
    content?: string;
    textWrapper?: string;
    text?: string;
  };
  title?: string;
  text?: string[];
}

const CardSection: FC<CardSectionProps> = ({
  title,
  text,
  children,
  classes: additionalClasses,
}) => {
  const classes = useStyles();

  return (
    <div className={cx(classes.wrapper, additionalClasses?.wrapper)}>
      {title && (
        <Typography variant="h4" className={cx(classes.title, additionalClasses?.title)}>
          {title}
        </Typography>
      )}
      <div className={cx(classes.content, additionalClasses?.content)}>
        {text && text.length > 0 && (
          <div className={cx(classes.textWrapper, additionalClasses?.textWrapper)}>
            {text.map((item) => (
              <Typography key={item} className={cx(classes.text, additionalClasses?.text)}>
                {item}
              </Typography>
            ))}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default CardSection;
